export const TYPES = {
  MANDATAIRE_IND: "individuel",
  MANDATAIRE_PRE: "préposé",
  SERVICE: "service",
};
